// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-gold: #E3B657; 
  --color-white:#F9EBDB;
  --bg-main: black;
  scrollbar-color: var(--color-gold) var(--uncheck-color) !important;
  scrollbar-width: thin !important;
}
.bg-main {
  background-color: var(--bg-main);
}
.color-white {
  color: var(--color-white);
}

/* Lumyxpo Section */

.lumyxpo-logo {
  padding-left: 12rem;
  position: absolute;
  top: 3rem;
}
.lumyxpo-title {
  font-family: "Comic Sans MS", "Comic Sans", cursive;
  color: #fff;
  padding-left: 12rem;
  font-size: 4rem;
}
.arrow-rotate {
  transform: rotate(80deg);
}
.lumyxpo-lamp {
  margin-top: 7rem;
  margin-left: -25px;
}

@media screen and (min-width: 1400px) {
  .coming-soon {
    padding: 10% 0;
  }
}

@media screen and (max-width: 1200px) {
  .lumyxpo-title {
    padding-left: 5rem;
  }
}

@media screen and (max-width: 767px) {
  .lumyxpo-logo {
    padding-left: 5rem;
    top: 20%;
  }
  .lumyxpo-title {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    padding-left: 5rem;
    font-size: 4rem;
  }
}

@media screen and (max-width: 576px) {
  .lumyxpo-logo {
    padding-left: 2rem;
    top: 10%;
  }
  .lumyxpo-title {
    position: absolute;
    top: 40%;
    transform: translateY(-50%);
    padding-left: 2rem;
    font-size: 4rem;
  }
  .lumyxpo-wave {
    display: none;
  }
  .lumyxpo-lamp {
    position: absolute;
    top: 75%;
    left: 25%;
    transform: translateY(-50%);
    margin-top: 0 !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/style/style.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,kEAAkE;EAClE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;;AAEpB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,mDAAmD;EACnD,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,QAAQ;EACV;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,QAAQ;EACV;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B,wBAAwB;EAC1B;AACF","sourcesContent":[":root {\n  --color-gold: #E3B657; \n  --color-white:#F9EBDB;\n  --bg-main: black;\n  scrollbar-color: var(--color-gold) var(--uncheck-color) !important;\n  scrollbar-width: thin !important;\n}\n.bg-main {\n  background-color: var(--bg-main);\n}\n.color-white {\n  color: var(--color-white);\n}\n\n/* Lumyxpo Section */\n\n.lumyxpo-logo {\n  padding-left: 12rem;\n  position: absolute;\n  top: 3rem;\n}\n.lumyxpo-title {\n  font-family: \"Comic Sans MS\", \"Comic Sans\", cursive;\n  color: #fff;\n  padding-left: 12rem;\n  font-size: 4rem;\n}\n.arrow-rotate {\n  transform: rotate(80deg);\n}\n.lumyxpo-lamp {\n  margin-top: 7rem;\n  margin-left: -25px;\n}\n\n@media screen and (min-width: 1400px) {\n  .coming-soon {\n    padding: 10% 0;\n  }\n}\n\n@media screen and (max-width: 1200px) {\n  .lumyxpo-title {\n    padding-left: 5rem;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .lumyxpo-logo {\n    padding-left: 5rem;\n    top: 20%;\n  }\n  .lumyxpo-title {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    padding-left: 5rem;\n    font-size: 4rem;\n  }\n}\n\n@media screen and (max-width: 576px) {\n  .lumyxpo-logo {\n    padding-left: 2rem;\n    top: 10%;\n  }\n  .lumyxpo-title {\n    position: absolute;\n    top: 40%;\n    transform: translateY(-50%);\n    padding-left: 2rem;\n    font-size: 4rem;\n  }\n  .lumyxpo-wave {\n    display: none;\n  }\n  .lumyxpo-lamp {\n    position: absolute;\n    top: 75%;\n    left: 25%;\n    transform: translateY(-50%);\n    margin-top: 0 !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
